module.exports = new __parcel__URL__("C7O4.b9c156fd.png").toString();